import React from "react";
import { Row } from "react-bootstrap";
import { SmsReminders } from "./SMSComms";
import { EmailReminders } from "./EmailComms";
import { AccountsEmail } from "./AccountsEmail";

export function Comms({ initialTab = "sms" }) {
  return (
    <div>
      <div className="container-fluid px-md-1 bg-white mt-0" style={{ maxWidth: "1400px" }}>
        <Row className="ms-1 mb-1">
          {initialTab === "sms" && <SmsReminders />}
          {initialTab === "email" && <EmailReminders />}
          {initialTab === "accounts" && <AccountsEmail />}
        </Row>
      </div>
    </div>
  );
}
